export default "__VITE_ASSET__pwCwuaS3__"